import { useContext, useState } from "react";
import Configuration from "./Configuration/Configuration";
import Colors from "./Colors/Colors";
import Mountings from "./Windows/Mountings";
import ProductSize from "./ProductSize/ProductSize";
import CloseButton from "./Buttons/CloseButton";
import HamburguerButton from "./Buttons/HamburguerButton";
import { MobileContext } from "../App";

function UserInterface(props) {
  const { isMobile } = useContext(MobileContext);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const toggleSidebarState = () => {
    setIsSidebarOpen(!isSidebarOpen);
    props.toggleCanvasOverlay();
  };

  const sidebarOpeningClass = () => isSidebarOpen ? 'panel-container--mobile-open' : '';
  const sidebarMobileClass = () => isMobile ? 'panel-container--mobile' : '';
  const sidebarDirectionClass = () => `panel-${props.documentDirection}`;

  const loadMobileHamburguerButton = () => isMobile ? (<HamburguerButton onClick={toggleSidebarState} hide={isSidebarOpen} />) : null;
  const loadMobileCloseButton = () => isMobile ? (<CloseButton onClick={toggleSidebarState} />) : null;

  return (
    <div className="user-interface__container">
      {loadMobileHamburguerButton()}
      <div className={`panel-container ${sidebarDirectionClass()} ${sidebarMobileClass()} ${sidebarOpeningClass()}`}>
        {loadMobileCloseButton()}
        <Configuration />
        <Colors />
        <ProductSize />
        <Mountings />
      </div>
    </div>
  );
}

export default UserInterface;
